<template>
  <div>
    <Widget>
      <h2 class="page-title text-center">Tambah Rencana Aksi Pusat</h2>

      <b-form>
        <div class="row">
          <div class="col-12">
            <legend class="text-black fw-bold">Identitas KKPRL</legend>
          </div>
          <div class="col-md-6 mb-3">
            <label for="no_kkprl">Nomor KKPRL <span class="text-danger">*</span></label>
            <i
              class="fa fa-info-circle ml-1"
              v-b-tooltip.hover.topright="
                'Mohon input secara manual apabila Nomor KKPRL/OSS belum tersedia di dalam sistem'
              "
            />
            <div class="d-flex">
              <b-form-input id="no_kkprl" v-model="form.no_kkprl" v-validate="'required'" name="Nomor KKPRL" />
              <b-button
                type="button"
                class="ms-2"
                variant="secondary"
                aria-label="Cari Nomor KKPRL"
                :disabled="!form.no_kkprl.trim() || isSearchingKkprl"
                @click="searchKkprlByNomor(form.no_kkprl.trim())"
              >
                <i class="fa fa-search" />
              </b-button>
            </div>
            <span v-if="errors.has('Nomor KKPRL')" class="text-danger">{{ errors.first('Nomor KKPRL') }}</span>
          </div>

          <div class="col-md-6 mb-3">
            <label for="jenis_kegiatan">Jenis Kegiatan <span class="text-danger">*</span></label>
            <v-select
              input-id="jenis_kegiatan"
              v-model="form.jenis_kegiatan"
              :options="['Berusaha', 'Non Berusaha']"
              v-validate="'required'"
              name="Jenis Kegiatan"
            />
            <span v-if="errors.has('Jenis Kegiatan')" class="text-danger">{{ errors.first('Jenis Kegiatan') }}</span>
          </div>

          <div class="col-md-6 mb-3">
            <label for="nama_pemegang">Nama Pemegang <span class="text-danger">*</span></label>
            <b-form-input
              id="nama_pemegang"
              v-model="form.nama_pemegang"
              v-validate="'required'"
              name="Nama Pemegang"
            />
            <span v-if="errors.has('Nama Pemegang')" class="text-danger">{{ errors.first('Nama Pemegang') }}</span>
          </div>

          <div class="col-md-6 mb-3">
            <label for="npwp">NPWP <span class="text-danger">*</span></label>
            <b-form-input
              id="npwp"
              v-model="form.npwp"
              v-validate="'required'"
              name="NPWP"
              v-mask="'##.###.###.#-###.####'"
            />
            <span v-if="errors.has('NPWP')" class="text-danger">{{ errors.first('NPWP') }}</span>
          </div>

          <div v-if="form.jenis_kegiatan === 'Berusaha'" class="col-md-6 mb-3">
            <label for="nib">NIB <span class="text-danger">*</span></label>
            <b-form-input id="nib" v-model="form.nib" v-validate="'required'" name="NIB" />
            <span v-if="errors.has('NIB')" class="text-danger">{{ errors.first('NIB') }}</span>
          </div>

          <div class="col-md-6 mb-3">
            <label>Provinsi <span class="text-danger">*</span></label>
            <v-select
              v-model="form.provinsi"
              :options="provinsiOptions"
              :reduce="(data) => data.nama_provinsi"
              label="nama_provinsi"
              multiple
              v-validate="'required'"
              name="Provinsi"
            />
            <span v-if="errors.has('Provinsi')" class="text-danger">{{ errors.first('Provinsi') }}</span>
          </div>

          <div class="col-md-6 mb-3">
            <label for="tanggal_terbit">Tanggal Terbit <span class="text-danger">*</span></label>
            <b-form-input
              id="tanggal_terbit"
              v-model="form.tanggal_terbit"
              type="date"
              v-validate="'required'"
              name="Tanggal Terbit"
            />
            <span v-if="errors.has('Tanggal Terbit')" class="text-danger">{{ errors.first('Tanggal Terbit') }}</span>
          </div>

          <div class="col-12 mt-4">
            <legend class="text-black fw-bold">Rencana Aksi</legend>
          </div>
          <div class="col-md-6 mb-3">
            <label>Jenis Rencana Aksi <span class="text-danger">*</span></label>
            <v-select
              v-model="form.jenis_rencana_aksi"
              :options="['Pertama', 'Lanjutan']"
              v-validate="'required'"
              name="Jenis Rencana Aksi"
            />
            <span v-if="errors.has('Jenis Rencana Aksi')" class="text-danger">{{
              errors.first('Jenis Rencana Aksi')
            }}</span>
          </div>
          <div class="col-md-6 mb-3">
            <label>Metode Penilaian Pelaksanaan <span class="text-danger">*</span></label>
            <v-select
              v-model="form.metode_penilaian_pelaksanaan"
              :options="['Lapangan', 'Terpusat']"
              v-validate="'required'"
              name="Metode Penilaian Pelaksanaan"
            />
            <span v-if="errors.has('Metode Penilaian Pelaksanaan')" class="text-danger">{{
              errors.first('Metode Penilaian Pelaksanaan')
            }}</span>
          </div>
          <div class="col-md-6 mb-3">
            <label>Prioritas <span class="text-danger">*</span></label>
            <v-select
              v-model="form.prioritas"
              :options="[
                { text: 'Ya', value: true },
                { text: 'Tidak', value: false },
              ]"
              :reduce="(data) => data.value"
              label="text"
              v-validate="'pilih_prioritas'"
              name="Prioritas"
            />
            <span v-if="errors.has('Prioritas')" class="text-danger">{{ errors.first('Prioritas') }}</span>
          </div>
          <div class="col-md-6 mb-3">
            <label for="tanggal_penilaian">Tanggal Penilaian <span class="text-danger">*</span></label>
            <b-form-input
              id="tanggal_penilaian"
              v-model="form.tanggal_penilaian"
              type="date"
              v-validate="'required'"
              name="Tanggal Penilaian"
            />
            <span v-if="errors.has('Tanggal Penilaian')" class="text-danger">{{
              errors.first('Tanggal Penilaian')
            }}</span>
          </div>
          <div class="col-md-6 mb-3">
            <label for="lokasi_penilaian">Lokasi Penilaian <span class="text-danger">*</span></label>
            <b-form-input
              id="lokasi_penilaian"
              v-model="form.lokasi_penilaian"
              v-validate="'required'"
              name="Lokasi Penilaian"
            />
            <span v-if="errors.has('Lokasi Penilaian')" class="text-danger">{{
              errors.first('Lokasi Penilaian')
            }}</span>
          </div>
          <div class="col-md-6 mb-3">
            <label>Tim Penilai <span class="text-danger">*</span></label>
            <v-select
              v-model="form.id_tim_penilai"
              :options="timPenilaiOptions"
              :reduce="(data) => data.id"
              label="nama"
              multiple
              v-validate="'required'"
              name="Tim Penilai"
            />
            <span v-if="errors.has('Tim Penilai')" class="text-danger">{{ errors.first('Tim Penilai') }}</span>
          </div>
        </div>
      </b-form>

      <div class="d-flex justify-content-between mt-4">
        <b-button variant="danger" @click="$router.push({ name: 'RencanaAksiPusat' })">Kembali</b-button>
        <b-button variant="success" :disabled="isSubmitting" @click="submitForm"
          >Simpan <i class="fa fa-check"
        /></b-button>
      </div>
    </Widget>
  </div>
</template>

<script>
import axios from 'axios'
import Swal from 'sweetalert2'
import Widget from '@/components/Widget/Widget'
import vSelect from 'vue-select'
import api from '@/services/api'
import { Validator } from 'vee-validate'
import { buildRencanaAksiFormData } from '../rencanaAksiFormData'

export default {
  name: 'FormTambahRencanaAksiPusat',
  components: { Widget, vSelect },
  data() {
    return {
      id_laporan_tahunan: null,
      isSearchingKkprl: false,
      isSubmitting: false,
      timPenilaiOptions: [],
      provinsiOptions: [],
      prioritasOptions: [
        { text: 'Ya', value: true },
        { text: 'Tidak', value: false },
      ],
      form: {
        no_kkprl: '',
        jenis_kegiatan: null,
        npwp: '',
        nama_pemegang: '',
        nib: '',
        provinsi: null,
        tanggal_terbit: '',
        jenis_rencana_aksi: null,
        metode_penilaian_pelaksanaan: null,
        prioritas: null,
        tanggal_penilaian: '',
        lokasi_penilaian: '',
        id_tim_penilai: [],
      },
    }
  },
  async mounted() {
    Validator.localize({
      id: {
        messages: {
          required: (fieldName) => `${fieldName} wajib diisi`,
          email: () => 'Email tidak valid',
        },
      },
    })
    this.$validator.localize('id')
    Validator.extend('pilih_prioritas', {
      getMessage: (fieldName) => `${fieldName} wajib diisi`,
      validate: (value) => value === true || value === false,
    })
    await Promise.all([this.getTimPenilai(), this.getProvinsi()])

    const nomorKkprl = this.$route.query.no_kkprl
    if (nomorKkprl) {
      this.form.no_kkprl = nomorKkprl
      await this.searchKkprlByNomor(nomorKkprl)
    }
  },
  watch: {
    'form.jenis_kegiatan'(jenisKegiatan) {
      if (jenisKegiatan !== 'Berusaha') {
        this.form.nib = ''
        this.errors.remove('NIB')
      }
    },
  },
  methods: {
    async searchKkprlByNomor(nomor) {
      if (!nomor || this.isSearchingKkprl) return

      this.isSearchingKkprl = true
      try {
        const response = await api.get(`api/laporan_tahunan?filter=nomor_kkprl,=,${encodeURIComponent(nomor)}`)
        const data = response.data.data.find((item) => String(item.nomor_kkprl).trim() === nomor)
        if (!data) {
          await Swal.fire({
            icon: 'info',
            title: 'Data tidak ditemukan',
            text: 'Silakan isi data secara manual.',
          })
          return
        }

        this.applyKkprlData(data)
      } catch (error) {
        await Swal.fire({
          icon: 'error',
          title: 'Pencarian gagal',
          text: 'Terjadi kesalahan saat mencari Nomor KKPRL.',
        })
      } finally {
        this.isSearchingKkprl = false
      }
    },
    applyKkprlData(data) {
      this.id_laporan_tahunan = data.id || null
      this.form.jenis_kegiatan = ['Berusaha', 'Non Berusaha'].includes(data.jenis_kegiatan) ? data.jenis_kegiatan : null
      const provinsi = Array.isArray(data.provinsi) ? data.provinsi : data.provinsi ? [data.provinsi] : []
      provinsi.forEach((nama) => {
        if (!this.provinsiOptions.some((option) => option.nama_provinsi === nama)) {
          this.provinsiOptions.push({ nama_provinsi: nama })
        }
      })
      this.form.nama_pemegang = data.nama_pemegang || ''
      this.form.npwp = data.npwp || ''
      this.form.nib = this.form.jenis_kegiatan === 'Berusaha' ? data.nib || '' : ''
      this.form.provinsi = provinsi
      this.form.tanggal_terbit = data.tanggal_penerbitan || ''
    },
    async getTimPenilai() {
      const response = await api.get('api/user?filter=roles,contains,Penilai;nama_upt,=,PUSAT&limit=0')
      this.timPenilaiOptions = response.data.data
    },
    async getProvinsi() {
      const response = await api.get('api/provinsi?sort=id,ASC&limit=0')
      this.provinsiOptions = response.data.data
    },
    async validateForm() {
      return (await this.$validator.validateAll()) && !this.errors.any()
    },
    getFormData() {
      return { ...this.form, id_tim_penilai: [...this.form.id_tim_penilai] }
    },
    async submitForm() {
      if (!(await this.validateForm())) return

      const result = await Swal.fire({
        icon: 'question',
        title: 'Simpan Rencana Aksi?',
        text: 'Apakah Anda yakin ingin menyimpan Rencana Aksi ini?',
        showCancelButton: true,
        confirmButtonText: 'Ya, Simpan',
        cancelButtonText: 'Batal',
      })
      if (!result.isConfirmed) return

      this.isSubmitting = true
      try {
        const response = await api.post('api/rencana_aksi', buildRencanaAksiFormData(this.form))
        const idRencanaAksi = response.data?.data?.id

        if (this.id_laporan_tahunan && idRencanaAksi) {
          await api.post(`api/laporan_tahunan/${this.id_laporan_tahunan}`, {
            id_rencana_aksi: idRencanaAksi,
          })
        }

        await Swal.fire({
          icon: 'success',
          title: 'Berhasil',
          text: 'Rencana Aksi berhasil disimpan.',
        })
        this.$router.push({ name: 'RencanaAksiPusat' })
      } catch (error) {
        await Swal.fire({
          icon: 'error',
          title: 'Gagal',
          text: 'Terjadi kesalahan saat menyimpan Rencana Aksi.',
        })
      } finally {
        this.isSubmitting = false
      }
    },
  },
}
</script>
